import { makeStyles } from '@material-ui/core/styles';

import { SizeDimention } from '../../models/models';

const useStyles = makeStyles({
  card: {
    padding: '16px',
    overflowY: 'hidden',
    borderRadius: 0,
  },
  dynamicProp1: {
    marginTop: 1,
    marginBottom: 1,
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
  },
  otherPropText: {
    padding: '8.5px 0px 7.5px 4px',
    fontStyle: 'normal',
  },
  staticValues: {
    lineHeight: 1.35,
    overflowWrap: 'anywhere',
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  flexColumn: {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
  },
  labelStyle: {
    fontStyle: 'normal',
    lineHeight: 1.35,
  },
  entityGrid: {
    padding: '3px 16px',
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '0px',
  },
  mainGrid: {
    display: (props: SizeDimention) =>
      props?.size?.height > props?.size?.width ? 'inline' : 'flex',
    flexDirection: 'row',
  },
});

export default useStyles;
